// Instagram リールの音楽選択(ig-music / ig-music-picker)で使う純関数

export function formatDuration(ms) {
  if (!Number.isFinite(ms) || ms < 0) return ""
  const totalSeconds = Math.floor(ms / 1000)
  return `${Math.floor(totalSeconds / 60)}:${String(totalSeconds % 60).padStart(2, "0")}`
}

// 動画のどこを再生中でも楽曲がループしている前提の近似位置
export function loopPosition(videoTime, audioDuration) {
  if (!Number.isFinite(videoTime) || !Number.isFinite(audioDuration) || audioDuration <= 0) return 0
  return videoTime % audioDuration
}

export function safeHttpsUrl(url) {
  return typeof url === "string" && url.startsWith("https://") ? url : null
}

// iOS/iPadOS の Safari は volume を JS から変えられない。UA ではなく、代入して読み戻せるかで判定する
export function canControlVolume(mediaEl) {
  try {
    const previous = mediaEl.volume
    mediaEl.volume = 0.5
    const controllable = Math.abs(mediaEl.volume - 0.5) < 0.01
    mediaEl.volume = previous
    return controllable
  } catch {
    return false
  }
}

export function searchHeading(query) {
  const q = String(query ?? "").trim()
  return q ? `『${q}』の検索結果` : "トレンドの楽曲"
}
